exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tile[data-v-6b6d696a] {\n  background: #fff;\n  border-color: #fff;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4);\n  padding: 15px;\n  color: #444;\n  border: 1px solid #ddd;\n}\n.tile[data-v-6b6d696a]:hover {\n    border: 1px solid #c5c5c5;\n    box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.5);\n}\n.tile__header[data-v-6b6d696a] {\n    width: 100%;\n    border-bottom: solid 1px #ebe7ed;\n    padding-bottom: 10px;\n}\n", ""]);

// exports
